export default {
  default: require('./default.png'),
  search: require('./search.png'),
  calendar: require('./calendar.png'),
  computer: require('./computer.png')
}
